import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import IntroHeadlineOpeners from "./sections/IntroHeadlineOpeners";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <IntroHeadlineOpeners />
      <Footer />
    </div>;
}